import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationFormContext } from '../../requests/getApplicationFormContext';

export const useApplicationFormContext = (
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationFormContext>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'form-context', params],
    queryFn: () =>
      getApplicationFormContext(constructGet, uuid, definitionName, params),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'formContext'),
    ...rest,
  };
};
